__turbopack_context__.v({
  "buttonWrapper": "ShowMore-module-scss-module__v4Bv2W__buttonWrapper",
  "root": "ShowMore-module-scss-module__v4Bv2W__root",
});
